import { render, staticRenderFns } from "./widget_competitions.vue?vue&type=template&id=521db470&"
import script from "./widget_competitions.vue?vue&type=script&lang=js&"
export * from "./widget_competitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LiveLine: require('/var/web/bet777.es/components/live/line.vue').default})
